import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AucFooterModule } from "@auction-ui/footer/footer.module";
import { AucRootUnAuthnComponent } from "@auction-ui/root/unauthn/root.unauthn.component";
import { MfAuthModule, MfFooterModule, MfIconModule, MfRootModule, MfUserPersonaModule } from "@pattonair/material-framework";


@NgModule({
  declarations: [
    AucRootUnAuthnComponent
  ],
  exports: [
    AucRootUnAuthnComponent
  ],
  imports: [
    BrowserModule,
    MfRootModule,
    MfAuthModule,
    MfUserPersonaModule,
    MfIconModule,
    MfFooterModule,
    MatButtonModule,
    RouterModule,
    AucFooterModule,
  ],
})
export class AucRootUnAuthnModule {
}